"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = NoteItem;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const react_native_linear_gradient_1 = __importDefault(require("react-native-linear-gradient"));
const useDevice_1 = require("../../../hooks/useDevice");
const useRequest_1 = __importDefault(require("../../../hooks/useRequest"));
const AppText_1 = require("../../../component/AppText");
const NoteIcon_1 = __importDefault(require("./NoteIcon"));
const DeleteButton_1 = __importDefault(require("./DeleteButton"));
const document_1 = require("../../../services/document");
const utils_1 = require("../../../helper/utils");
const colors_1 = require("../../../common/colors");
;
function NoteItem({ note, isActive, isCompactSize, onDeleteStart, onDelete, onDeleteSuccessufully, ...restProps }) {
    const { isMobileScreen } = (0, useDevice_1.useDevice)();
    const { request } = (0, useRequest_1.default)();
    const handleDeleteNote = (0, react_1.useCallback)(() => {
        onDeleteStart?.(note);
        request(document_1.deleteNote, note.id).then((response) => {
            onDelete?.(note);
            if (response) {
                onDeleteSuccessufully?.(note);
            }
        });
    }, [note, onDeleteStart, onDelete, onDeleteSuccessufully, request]);
    return ((0, jsx_runtime_1.jsx)(react_native_1.Pressable, { ...restProps, children: (0, jsx_runtime_1.jsxs)(react_native_linear_gradient_1.default, { colors: isActive
                ? ['rgba(157, 237, 248, 0.24)', 'rgba(59, 149, 197, 0.24)']
                : (isMobileScreen || isCompactSize)
                    ? ['rgba(18, 18, 24, 0.40)', 'rgba(18, 18, 24, 0.40)']
                    : ['transparent', 'transparent'], locations: [0.0479, 0.9512], useAngle: true, angle: 204, style: [styles.container, (isMobileScreen || isCompactSize) && styles.containerMobile], children: [(0, jsx_runtime_1.jsx)(NoteIcon_1.default, { isActive: isActive }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { numberOfLines: 1, style: [
                        styles.text,
                        (isMobileScreen || isCompactSize) && styles.textMobile,
                        isActive && styles.textActive
                    ], children: note.title }), (isMobileScreen || isCompactSize) && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.date, children: (0, utils_1.formatDate)(note.updatedAt) }), (0, jsx_runtime_1.jsx)(DeleteButton_1.default, { onPress: handleDeleteNote })] }))] }) }));
}
;
const styles = react_native_1.StyleSheet.create({
    container: {
        gap: 8,
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: 4,
        borderRadius: 2,
    },
    containerMobile: {
        gap: 12,
        padding: 16,
        paddingHorizontal: 16,
        borderRadius: 12,
    },
    text: {
        color: colors_1.Colors.DARK_100,
        fontSize: 12,
        lineHeight: 24,
        flex: 1,
    },
    textMobile: {
        color: '#FFF',
        fontSize: 18,
        fontWeight: '700',
        lineHeight: 20,
    },
    textActive: {
        color: '#FFF',
        fontWeight: '700',
    },
    date: {
        color: colors_1.Colors.NEUTRAL_25,
        fontSize: 12,
        lineHeight: 20,
    }
});
